export default "__VITE_ASSET__CeZ327f3__"